import configuration from '../configuration';

export default function canBePostedWithoutCalculation(dataIndex) {
  const config = configuration();
  return config && config.postWithoutRun.includes(dataIndex);
}
